import React from 'react';
import { Box, LinearProgress, Typography, type LinearProgressProps } from '@mui/material';

function LinearProgressWithLabel(props: LinearProgressProps) {
	return (
		<Box display="flex" alignItems="center">
			<Box width="100%" mr={1}>
				<LinearProgress variant="determinate" {...props} />
			</Box>
			<Box minWidth={35}>
				<Typography variant="body2" color="textSecondary">{`${Math.round(props.value || 0)}%`}</Typography>
			</Box>
		</Box>
	);
}

export default React.memo(LinearProgressWithLabel);
